import React, { useEffect, useRef } from 'react';
import { sliderImages, getSliderImage } from './data/galleryData';

/**
 * Slider Component (Optimized)
 * - Converted to functional component with hooks
 * - Data-driven approach instead of hardcoded requires
 * - Lazy loading via Swiper's built-in lazy feature
 * - Efficient cleanup of Swiper instance
 */
const Slider = () => {
    const swiperRef = useRef(null);

    useEffect(() => {
        // Initialize Swiper only after component mounts
        if (!window.Swiper || !swiperRef.current) return;

        const swiper = new window.Swiper(swiperRef.current, {
            slidesPerView: 1,
            lazy: true,
            loop: true,
            autoplay: {
                delay: 2500,
                disableOnInteraction: false,
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
                dynamicBullets: true,
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        });

        // Cleanup Swiper instance on component unmount
        return () => {
            if (swiper) {
                swiper.destroy(true, true);
            }
        };
    }, []);

    const slides = sliderImages.map((item) => (
        <div className="swiper-slide" key={item.id}>
            <img
                data-src={getSliderImage(item.name)}
                alt={item.alt}
                className="swiper-lazy"
            />
            <div className="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
        </div>
    ));

    return (
        <div className="swiper-container" ref={swiperRef}>
            <div className="swiper-wrapper">
                {slides}
            </div>
            <div className="swiper-pagination"></div>
            {/* <div className="swiper-button-next"></div> */}
            {/* <div className="swiper-button-prev"></div> */}
        </div>
    );
};

export default Slider;
